import { NextButtonComponent } from './button/next-button/next-button.component';
import { PreviousButtonComponent } from './button/previous-button/previous-button.component';
import { NgModule } from '@angular/core';
import { InputComponent } from './input/input.component';
import { ValidationDirective } from './directives/validation.directive';
import { PostCodeValidatorDirective } from './validators/postcode-validator';
import { EmailValidatorDirective } from './validators/email-validator';
import { PasswordValidatorDirective } from './validators/password-validator';
import { MessageComponent } from './message/message.component';
import { MessagesComponent } from './messages/messages.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BirthDateValidatorDirective } from './validators/birthdate-validator';
import {FieldComponent} from './field/field.component';
import { OptionComponent } from './option/option.component';
import { RadioBoxComponent } from './radio-box/radio-box.component';
import { SelectComponent } from './select/select.component';
import { CheckBoxComponent } from './checkbox/checkbox.component';
import { WhiteSpaceValidatorDirective } from './validators/whitespace-validator';
import { ButtonComponent } from './button/button.component';
import {SaveDraftRequeteButtonComponent} from './button/save-draft-requete-button/save-draft-requete-button.component';

@NgModule({
    imports: [
      CommonModule ,
      FormsModule
    ],
    declarations: [
        ValidationDirective,
        PostCodeValidatorDirective,
        EmailValidatorDirective,
        PasswordValidatorDirective,
        BirthDateValidatorDirective,
        WhiteSpaceValidatorDirective,
        MessageComponent,
        MessagesComponent,
        InputComponent,
        OptionComponent,
        RadioBoxComponent,
        SelectComponent,
        CheckBoxComponent,
        FieldComponent,
        ButtonComponent,
        PreviousButtonComponent,
        NextButtonComponent,
        SaveDraftRequeteButtonComponent
    ],
    exports: [
        ValidationDirective,
        PostCodeValidatorDirective,
        EmailValidatorDirective,
        PasswordValidatorDirective,
        BirthDateValidatorDirective,
        WhiteSpaceValidatorDirective,
        MessageComponent,
        MessagesComponent,
        InputComponent,
        OptionComponent,
        RadioBoxComponent,
        SelectComponent,
        CheckBoxComponent,
        FieldComponent,
        ButtonComponent,
        PreviousButtonComponent,
        NextButtonComponent,
        SaveDraftRequeteButtonComponent
    ]
})
export class TelerecoursFormModule {
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/forms/form.module.ts